// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content__7SlVb","topContainer":"index_topContainer__IPrzq","collapseContent":"index_collapseContent__N7fOj"};